import { Dialog, Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseIcon.svg"
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import styles from '../../../../studentRefund/refundStyles.module.scss';
import ALoader from 'views/pages/manage/common/a-loader';
// import ApprovalSettingTable from './ApprovalSettingTable';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import ApprovalSettingTable from './ApprovalSettingTable';
import useCashierOfficeDropdown, { DIGITAL_BUSINESS_IDS } from '../../../../../views/pages/manage/common/hook/useCashierOfficeDropdown';
import { fetchAllPromisedData } from '../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from 'views/pages/manage/common/constant';
import { IoMdInformationCircleOutline } from 'react-icons/io';


const labelStyle = {
    fontWeight: 600,
    fontSize: '12px',
    color: '#262626'
}

const AddEditConfigDialog = ({
    open,
    form,
    setForm,
    handleForm,
    dropdownData,
    handleClose,
    createUpdateConfigHandler,
    buLoading,
    loading,
    setLoading,
    buTypeChangeHandler
}) => {

    const { businessAreas, branchType, allActiveRoles } = dropdownData;
    const ref = useRef();
    const [cashierItems, setCashierItems] = useState([]);
    const [selectedCashiers, setSelectedCashiers] = useState(form?.cashier || []);
    const [isCashierLoading, setIsCashierLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    // const [isAdvanceBranchType, setIsAdvanceBranchType] = useState(false);

    useEffect(() => {
        if (!form?.businessArea?.length) {
            setDisabled(true);
            return;
        }
        const allowed = form?.businessArea?.every(bu => DIGITAL_BUSINESS_IDS?.includes(bu?.label));
        if (allowed) {
            setDisabled(false);
        } else {
            setDisabled(true);
            handleForm("cashierOffices", null);
            setSelectedCashiers(null);
        }
    }, [form?.businessArea]);

    useEffect(() => {
        const fetchCashiers = async () => {
            try {
                setIsCashierLoading(true);
                const data = await fetchAllPromisedData(endpoint?.businessArea?.getCashierOfficeDetails);
                if (Array.isArray(data)) {
                    const transformed = data.map((item) => ({
                        label: item?.businessAreaDispValue,
                        value: item?.businessAreaDispValue,
                        raw: item,
                    }));
                    setCashierItems(transformed)
                } else {
                    console.log("Invalid response format for cashier office list.");
                }
            } catch (e) {
                console.log(e);
            }
            finally {
                setIsCashierLoading(false);
            }
        }
        fetchCashiers();
    }, []);

    const handleCashierChange = (val) => {
        setSelectedCashiers(val);
        handleForm("cashierOffices", val);
    }

    const isAdvanceBranchType = form?.branchType?.[0]?.label?.toLowerCase() == "advance" ? true : false;

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
        // scroll="paper"
        >
            {loading && <ALoader position="fixed" />}
            <div className='p-3'>
                <div className='d-flex justify-content-between'>
                    <h4>Payment management approval config</h4>
                    <CloseIcon onClick={handleClose} />
                </div>

                <div className={styles['dropdown-container']}>
                    <div className={styles['label']}>1. Basic Details</div>

                    <div className={styles['dropdowns']}>
                        <AAutoComplete
                            label='Branch Type*'
                            labelStyle={labelStyle}
                            items={branchType}
                            handleChange={buTypeChangeHandler}
                            currentValue={form?.branchType}
                            isMulti={false}
                        />

                        <AAutoComplete
                            label='Business area*'
                            labelStyle={labelStyle}
                            items={businessAreas}
                            handleChange={(val) =>
                                handleForm(
                                    "businessArea",
                                    isAdvanceBranchType
                                        ? val ? [val] : []
                                        : Array.isArray(val) ? val : val ? [val] : []
                                )
                            }
                            currentValue={
                                isAdvanceBranchType
                                    ? form?.businessArea?.[0] || null
                                    : form?.businessArea || []
                            }
                            isMulti={!isAdvanceBranchType}
                            isShowCount={!isAdvanceBranchType}
                            isLoading={buLoading}
                        />

                        <AAutoComplete
                            label={
                                <div className="d-flex align-items-center ">
                                    Cashier office
                                    {['Owned', 'Franchise', 'SubContractor'].includes(form?.branchType?.[0]?.label) && (
                                        <Tooltip title="Cashier office is same as that of Business area">
                                            <span className="d-flex align-items-center">
                                                <IoMdInformationCircleOutline
                                                    className="ml-2 pointer"
                                                    size={18}
                                                />
                                            </span>
                                        </Tooltip>
                                    )}
                                </div>
                            }
                            labelStyle={labelStyle}
                            items={cashierItems}
                            handleChange={handleCashierChange}
                            currentValue={selectedCashiers}
                            isMulti={true}
                            isShowCount={true}
                            isDisabled={disabled}
                            loading={isCashierLoading}
                        />

                    </div>

                </div>

                <div className={styles['dropdown-container']}>
                    <div className='d-flex justify-content-between'>
                        <div className={styles['label']}>2. Approval Setting</div>
                        <AButton
                            variant='outline'
                            size='xs'
                            onClick={() => ref.current.addNewRow()}
                        >
                            Add new
                        </AButton>
                    </div>
                    <ApprovalSettingTable
                        allActiveRoles={allActiveRoles}
                        ref={ref}
                        rows={form?.approvalSettingDTO}
                        form={form}
                        setForm={setForm}
                        setLoading={setLoading}
                    />


                </div>

                <AButton
                    variant='primary_filled'
                    className='float-right mt-3'
                    onClick={() => {
                        if (ref?.current?.isTableInEditMode) {
                            failureToast("Please save or discard current changes!");
                            return;
                        }
                        createUpdateConfigHandler();
                    }}
                    size="xs"
                    disabled={!form?.businessArea?.length || !form?.branchType || !form?.approvalSettingDTO?.length}

                >
                    Save Config
                </AButton>

            </div>
        </Dialog>
    )
}

export default AddEditConfigDialog;